if (!customElements.get("custom-quote-modal")) {
  customElements.define(
    "custom-quote-modal",
    class CustomQuoteModal extends ModalDialog {
      constructor() {
        super();
      }

      connectedCallback() {
        return;
      }

      show() {
        super.show();

        if (!this.popupInited) {
          this.countrySelect = document.getElementById("ShippingFormCountry");
          this.provinceSelect = document.getElementById("ShippingFormProvince");
          this.provinceWrapper = document.getElementById(
            "ShippingFormProvinceWrapper",
          );
          this.submitButton = document.getElementById("submit_button");
          this.form = document.getElementById("customShippingForm");
          this.statusDiv = document.getElementById("formStatus");
          this.countriesData = [];
          this.defaultKeys = [
            "firstName",
            "lastName",
            "email",
            "phone",
            "country",
            "city",
            "province",
            "zip",
            "address1",
            "address2",
            "address3",
            "residential_address",
            "have_shipping_dock",
            "require_inside_delivery",
            "specific_delivery",
            "delivery_instructions",
          ];

          if (this.countrySelect) {
            this.init();
          }

          this.popupInited = true;
        }
      }

      init() {
        this.fetchCountries();
        this.countrySelect.addEventListener("change", () =>
          this.handleCountryChange(),
        );
        if (this.form) {
          this.form.addEventListener("submit", (e) => this.handleSubmit(e));
        }
      }

      async fetchCountries() {
        const endpoint = "https://atlas.shopifysvc.com/graphql";
        const query = `
        query countries($locale: SupportedLocale!) {
          countries(locale: $locale) {
            name
            code
            zones {
              name
              code
            }
          }
        }
      `;

        try {
          const response = await fetch(endpoint, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              operationName: "countries",
              query: query,
              variables: { locale: "EN" },
            }),
          });

          const result = await response.json();
          if (result.errors) throw new Error(result.errors[0].message);

          this.countriesData = result.data.countries;
          this.populateCountrySelect();
        } catch (error) {
          console.error(error);
          this.statusDiv.innerText = "Error loading countries.";
          this.statusDiv.className = "form-status error";
        }
      }

      populateCountrySelect() {
        const defaultCode =
          this.countrySelect.getAttribute("data-default") || "US";
        this.countrySelect.innerHTML = "";

        this.countriesData.forEach((country) => {
          const option = document.createElement("option");
          option.value = country.code;
          option.text = country.name;
          if (country.code === defaultCode) option.selected = true;
          this.countrySelect.appendChild(option);
        });

        this.handleCountryChange();
      }

      handleCountryChange() {
        const selectedCode = this.countrySelect.value;
        const countryData = this.countriesData.find(
          (c) => c.code === selectedCode,
        );

        this.provinceSelect.innerHTML = "";

        if (countryData && countryData.zones && countryData.zones.length > 0) {
          this.provinceWrapper.style.display = "block";
          this.provinceSelect.setAttribute("required", "required");

          const defaultOption = document.createElement("option");
          defaultOption.text = "Select State";
          defaultOption.value = "";
          defaultOption.disabled = true;
          defaultOption.selected = true;
          this.provinceSelect.appendChild(defaultOption);

          countryData.zones.forEach((zone) => {
            const option = document.createElement("option");
            option.value = zone.code;
            option.text = zone.name;
            this.provinceSelect.appendChild(option);
          });
        } else {
          this.provinceWrapper.style.display = "none";
          this.provinceSelect.removeAttribute("required");
        }
      }

      getFieldLabel(inputName) {
        const inputElement = this.form.querySelector(`[name="${inputName}"]`);
        if (!inputElement) return inputName;

        const id = inputElement.id;
        const labelElement = this.form.querySelector(`label[for="${id}"]`);

        return labelElement.innerText || inputName;
      }

      async handleSubmit(e) {
        e.preventDefault();
        this.submitButton.disabled = true;
        const formData = new FormData(this.form);

        const payload = {};

        for (const [key, value] of formData.entries()) {
          if (!value) {
            continue;
          }
          if (this.defaultKeys.includes(key)) {
            if (
              key === "province" &&
              this.provinceWrapper.style.display === "none"
            ) {
              continue;
            }
            payload[key] = value;
          }
        }

        payload.requestId = crypto.randomUUID();

        this.statusDiv.innerText = "Sending...";
        this.statusDiv.className = "form-status";

        const submitUrl = this.form.getAttribute("data-submit-url");
        const variantId = this.form.getAttribute("data-variant-id");
        const quantity = document.querySelector(
          '.product__info-wrapper input[name="quantity"]',
        );

        payload.variant_id = "gid://shopify/ProductVariant/" + variantId;
        const parsedQuantity = Number(quantity?.value);
        payload.quantity = Number.isInteger(parsedQuantity) && parsedQuantity > 0
          ? parsedQuantity
          : 1;

        const headers = { "Content-Type": "application/json" };

        try {
          const response = await fetch(submitUrl, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(payload),
          });

          if (!response.ok) throw new Error();

          this.statusDiv.className = "form-status success";
          this.form.reset();
          this.populateCountrySelect();
          this.submitButton.disabled = false;
          this.statusDiv.innerHTML = "Request sent successfully!";
          setTimeout(() => {
            if (this) {
              this?.hide();
            }
            this.statusDiv.innerHTML = "";
          }, 2000);
        } catch (error) {
          this.submitButton.disabled = false;
          console.error(error);
          this.statusDiv.innerText = "Error sending form.";
          this.statusDiv.className = "form-status error";
        }
      }
    },
  );
}
